import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { NavMenu } from './NavMenu';
import Agency from './Agency/Agency'

export class Layout extends Component {

    constructor(props) {
        super(props);

        this.agency = new Agency(props);
    }

    displayName = Layout.name;

    render() {
        return (
            <Grid fluid>
                <Row>
                    <Col sm={2}>
                        <NavMenu auth={this.props.auth} />
                    </Col>
                    <Col sm={9}>
                        <div>
                            <h1>
                            </h1>
                        </div>
                        {this.props.children}
                    </Col>
                </Row >
            </Grid >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js